import PayOutServices from "@/services/PayOutServices";
import PayOutRequest from "@/model/requests/PayOutRequest";
import LoaderUtils from "@/utils/BaseUtils/LoaderUtils";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import PayOutAccountRequest from "@/model/requests/PayOutAccountRequest";
const payOutService = new PayOutServices();
export const namespaced = true;

export const state = {
  loading: false
};

export const getters = {};

export const mutations = {
  updatePayOutLoading: (state, payload) => {
    state.loading = payload;
  }
};

export const actions = {
  createPayOut({ commit }, payload = PayOutRequest.create) {
    let successAction = () => {};
    return payOutService.createPayOut(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  }
};
